const CategoryIndex = () => import('./categories/index.vue');
const CreateCategory = () => import('./categories/_pages/create.vue');
const ViewCategory = () => import('./categories/_pages/view.vue');

export default [
    {
        path: '/account-categories',
        component: CategoryIndex
    },
    {
        path: '/new-account-category',
        component: CreateCategory
    },
    {
        path: '/account-categories/:id',
        component: ViewCategory
    }
]